import { Phases, StatesGroups, ProformasStates } from '@arpada/arp-lib-common-qupro';
import { HttpHeaders } from '@angular/common/http';
export class Constants {

    public static readonly SUPPLIER_POSTSALE_PHASES_FILTER = [Phases.POSTSALE];
    public static readonly SUPPLIER_POSTSALE_STATES_GROUPS_INIT_FILTER = [
        StatesGroups.PENDING_PROCESSING,
        StatesGroups.PROCESSED_NO_DATE,
        StatesGroups.PROCESSED_DATE,
        StatesGroups.PENDING_MATERIAL,
        StatesGroups.NOT_APPLICABLE,
    ];
    public static readonly SUPPLIER_PRESALE_REVIEW_PHASES_FILTER = [Phases.REVIEW, Phases.PRESALE];
    public static readonly SUPPLIER_PRESALE_REVIEW_STATES_GROUPS_INIT_FILTER = [
        StatesGroups.PROCESSED_NO_DATE,
        StatesGroups.PROCESSED_DATE,
        StatesGroups.NOT_APPLICABLE,
    ];

    public static readonly SUPPLIER_PROFORMAS_STATES_FILTER = [
        ProformasStates.ACCEPTED,
        ProformasStates.INVOICED,
        ProformasStates.PENDING,
        ProformasStates.REJECTED,
    ];
    public static readonly NATIVE_MOBILE_PLATFORM = 'cordova';
    public static readonly IOS_PLATFORM = 'ios';
    public static readonly ANDROID_PLATFORM = 'android';
    public static readonly RESPONSE_TYPE_BLOB = 'blob';
    public static readonly POWER_BI_APP_ID_IOS_PLATFORM = 'mspbi://app/';
    public static readonly POWER_BI_APP_ID_ANDROID_PLATFORM = 'com.microsoft.powerbim';

    public static readonly MODE_PORTAL_REVIEW = 'portal-repasos-proveedor';
    public static readonly MODE_PORTAL_POSTSALE = 'portal-proveedor';

    public static getAppUrlPowerBi(appId: string): string {
        return 'mspbi://app/OpenApp?appId=' + appId; // + '&ctid=a50bd502-8030-42e4-8773-4acd5b7349b0',
    }

    public static getWebUrlPowerBi(appId: string): string {
        return 'https://app.powerbi.com/groups/me/apps/' + appId + '?ctid=a50bd502-8030-42e4-8773-4acd5b7349b0';
    }

    public static ADD_HEADERS_FOR_BLOB_FILE(headers: HttpHeaders): HttpHeaders {
        headers.append('Content-Type', 'application/octet-stream');
        headers.append('Content-Disposition', 'attachment');
        return headers;
    }
}
